
import { FC, useState, useRef, useEffect} from 'react';
import classNames from 'classnames';
import { useOnClickOutside } from 'usehooks-ts';

import './TimePickerInput.scss';

export type Props = {
    value: string;
    handleChanged: (time: string) => void;
};

const generateTimeOptions = () => {
    const options = [];
    for (let hour = 5; hour < 20; hour++) {
        for (let minutes of [0, 30]) {
            const time = `${String(hour).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
            options.push(time);
        }
    }
    return options;
};

export const TimePickerInput: FC<Props> = ({ value, handleChanged}) => {
	const ref = useRef(null);

    const [showOptions, setShowOptions] = useState(false);
    const [selectedTime, setSelectedTime] = useState(value);

    const timeOptions = generateTimeOptions()
    
    const handleTimeSelected = (time: string) => {
        setSelectedTime(time);
        handleChanged(time);
    }

    // Toggle the popup
	const handleOptionsClick = () => {
		setShowOptions(!showOptions);
	};

    const handleClickOutside = () => {
		setShowOptions(false);
	};

    // Setup on outside click handler
    useOnClickOutside(ref, handleClickOutside);

    useEffect(() => {
        setSelectedTime(value);
        handleChanged(value);
    }, [value]);

    return(
        <div className="time-picker-input" onClick={handleOptionsClick} ref={ref}>
            {value}
            {showOptions && (
            <div className="timeSelector-list">
                {timeOptions.map((time) => {
                    return (
                        <div
                            key={time}
                            className={classNames('timeSelector-list__item', {
                                'is-active': time === selectedTime,
                            })}
                            onClick={() => {
                                handleTimeSelected(time);
                                setShowOptions(!showOptions);
                            }}
                        >
                            {time}
                        </div>
                    );
                })}
            </div>
            )}
        </div>
    );
};

